// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.screenings {
    grid-template-columns: repeat(11, auto);
}
.grid.custom {
    grid-template-columns: repeat(6, auto);
}
.grid.custom-searches-display {
    grid-template-columns: repeat(2, auto);
}
.grid.custom-searches {
    grid-template-columns: repeat(2, auto);
}

button[type=submit] {
    display: block;
    
    font-weight: 500;
    color: white;
    width: 200px;
    border-radius: 50px;
    padding: 10px 30px;
    margin: 5% auto;
    border: 0;
    transition: 0.5s;
    text-transform: uppercase;
}
button[type=button]:hover {
    background: darkblue;
}

.holder {
    max-width: 100%;
}

form {
    background-color: #efeff7 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/packages-module/packages-add/packages-add.component.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;;IAEd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".grid.screenings {\r\n    grid-template-columns: repeat(11, auto);\r\n}\r\n.grid.custom {\r\n    grid-template-columns: repeat(6, auto);\r\n}\r\n.grid.custom-searches-display {\r\n    grid-template-columns: repeat(2, auto);\r\n}\r\n.grid.custom-searches {\r\n    grid-template-columns: repeat(2, auto);\r\n}\r\n\r\nbutton[type=submit] {\r\n    display: block;\r\n    \r\n    font-weight: 500;\r\n    color: white;\r\n    width: 200px;\r\n    border-radius: 50px;\r\n    padding: 10px 30px;\r\n    margin: 5% auto;\r\n    border: 0;\r\n    transition: 0.5s;\r\n    text-transform: uppercase;\r\n}\r\nbutton[type=button]:hover {\r\n    background: darkblue;\r\n}\r\n\r\n.holder {\r\n    max-width: 100%;\r\n}\r\n\r\nform {\r\n    background-color: #efeff7 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
